import { zodResolver } from '@hookform/resolvers/zod';
import { FC, PropsWithChildren } from 'react';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { z } from 'zod';
import { TestPushFormField } from './types';

const schema = z.object({
  [TestPushFormField.deviceToken]: z.string().min(1, 'Device token required to send test'),
  [TestPushFormField.testMessage]: z.string().min(1, 'Message required to send test'),
});

type TestPushFormValues = z.infer<typeof schema>;

export const TEST_PUSH_FORM_DEFAULT_VALUES = {
  [TestPushFormField.deviceToken]: '',
  [TestPushFormField.testMessage]: '',
};

export const TestPushFormProvider: FC<PropsWithChildren> = ({ children }) => {
  const methods = useForm<TestPushFormValues>({
    defaultValues: TEST_PUSH_FORM_DEFAULT_VALUES,
    mode: 'onChange',
    shouldUnregister: true,
    resolver: zodResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};

export const useTestPushFormContext = () => useFormContext<TestPushFormValues>();
